import { createFileRoute } from '@tanstack/react-router';

import { SupplierRfqDetailPage } from '@/features/supplier/rfq-detail-page';

export const Route = createFileRoute('/_app/supplier/$orgId/rfqs/$rfqId')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierRfqDetailPage {...params} />;
}
